export default "__VITE_ASSET__ESZxJiVj__"